"use client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ScreenSizeProvider } from "../store/context/screenSizesContext";
import { LoadingContextProvider } from "../store/context/isLoadingContext";
import { PopupProvider } from "../store/context/popupContext";
import { GetInTouchPopupProvider } from "../store/context/getInTouchPopupContext";
import { Suspense, useEffect } from "react";
import * as fbq from "../utils/fpixel";
import * as gtag from "../utils/gtag";
import { usePathname, useSearchParams } from "next/navigation";
import ScrollSmootherContainer from "../components/animation/ScrollSmoother";
import ConsoleWarningFilter from "../components/dev/ConsoleWarningFilter";

const queryClient = new QueryClient();

const PathnameTracker = () => {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    if (typeof window !== "undefined") {
      const timeout = setTimeout(() => {
        fbq.pageview();
        gtag.pageview(pathname + (searchParams?.toString() ? `?${searchParams.toString()}` : ""));
      }, 300); // important for Safari

      return () => clearTimeout(timeout);
    }
  }, [pathname, searchParams]);

  return null;
};

const Providers = ({ children }: { children: React.ReactNode }) => {
  return (
    <QueryClientProvider client={queryClient}>
      <Suspense fallback={null}>
        <PathnameTracker />
        <ConsoleWarningFilter />
      </Suspense>
      <ScreenSizeProvider>
        <LoadingContextProvider>
          <ScrollSmootherContainer>
            <PopupProvider>
              <GetInTouchPopupProvider>{children}</GetInTouchPopupProvider>
            </PopupProvider>
          </ScrollSmootherContainer>
        </LoadingContextProvider>
      </ScreenSizeProvider>
    </QueryClientProvider>
  );
};

export default Providers;

